module.exports = __webpack_public_path__ + "img/hime.2622834d.png";